module.exports = __webpack_public_path__ + "b8910a696d0918a58f5893abe9a7a0dd.jpg";